<template>
  <v-card color="" elevation="0" class="px-4">
    <v-divider></v-divider>
    <div class="d-flex pt-3 pb-7 mt-2">
      <v-text-field
        style="flex: 0 1 300px"
        v-model="search"
        append-icon="mdi-magnify"
        outlined
        :label="this.$t('sales.clientsList.search')"
        single-line
        dense
        hide-details
      ></v-text-field>
      <v-spacer></v-spacer>
    </div>
    <v-card outlined>
      <v-progress-linear indeterminate v-if="loadingPlan"></v-progress-linear>
      <v-data-table
        class="--total-fin"
        :headers="headers"
        v-if="!loadingPlan"
        :items="docs"
        :footer-props="{
          showFirstLastPage: true,
          'items-per-page-options': [10, 25, 50],
        }"
        :items-per-page="25"
        :search="search"
      >
        <template v-slot:[`item.createdOn`]="{ item }">
          <span class="hide-text">{{ item.createdOn }}</span
          >{{ item.createdOn | dateTime }}
        </template>
        <template v-slot:[`item.verified`]="{ item }">
          <template v-if="item.verified">
            <span class="hide-text">{{ item.verified }}</span>
            {{ item.verified | dateTime }}
          </template>
          <v-chip v-else label color="error lighten-2 " small>{{
            $t("sales.clientsList.confirmed")
          }}</v-chip>
        </template>
      </v-data-table>
    </v-card>
  </v-card>
</template>
<script>
import moment from "moment";
import config from "@/store/config";
// import { getAuth, onAuthStateChanged, signOut } from "firebase/auth";
import { initializeApp } from "firebase/app";

import {
  getFirestore,
  collection,
  query,
  where,
  getDocs,
} from "firebase/firestore";
export default {
  name: "FinancialTable",
  data() {
    return {
      docs: [],
      loadingPlan: true,
      currentPlan: null,
      loading: true,
      search: this.$route.query.q ? this.$route.query.q : "",
    };
  },
  async mounted() {
    this.loadOrders()
    await this.getCurrentPlan();
  },
  watch: {
    "$route.params.tab"(value) {
      if (value != 1)
        this.search = this.$route.query.q ? this.$route.query.q : "";
    },
  },
  computed: {
    headers() {
      return [
        {
          text: "Período",
          align: "center",
          sortable: true,
          value: "period",
        },
        {
          text: this.$t("financial.financialTable.totalGrossBilled"),
          align: "center",
          sortable: true,
          value: "totalGross",
        },
        {
          text: this.$t("financial.financialTable.totalNetReceived"),
          align: "center",
          sortable: true,
          value: "netReceived",
        },
        {
          text: this.$t("financial.financialTable.netAmountReceivable"),
          align: "center",
          sortable: true,
          value: "amountReceivable",
        },
        {
          text: this.$t("financial.financialTable.paymentTMTDate"),
          align: "center",
          sortable: true,
          value: "paymentTMT",
        },
      ]
    },

    documents() {
      return [
        // {
        //   period: "Geral",
        //   totalGross: this.$n(20000 + 14200 + 1450, "currency"),
        //   netReceived: this.currentPlan
        //     ? `${this.$n(
        //         ((100 - this.currentPlan._plan.commission) / 100) * 14200,
        //         "currency"
        //       )}`
        //     : "...",
        //   amountReceivable: this.currentPlan
        //     ? `${this.$n(
        //         ((100 - this.currentPlan._plan.commission) / 100) *
        //           (20000 + 1450),
        //         "currency"
        //       )} (${this.$n(100 - this.currentPlan._plan.commission)}%)`
        //     : "...",
        //   paymentTMT: "15/05/2023",
        // },
        // {
        //   period: "Maio",
        //   totalGross: this.$n(1450, "currency"),
        //   netReceived: this.$n(0, "currency"),
        //   amountReceivable: this.currentPlan
        //     ? `${this.$n(
        //         ((100 - this.currentPlan._plan.commission) / 100) * 1450,
        //         "currency"
        //       )} (${this.$n(100 - this.currentPlan._plan.commission)}%)`
        //     : "...",
        //   paymentTMT: "15/06/2023",
        // },
        // {
        //   period: "Abril",
        //   totalGross: this.$n(20000, "currency"),
        //   netReceived: this.$n(0, "currency"),
        //   amountReceivable: this.currentPlan
        //     ? `${this.$n(
        //         ((100 - this.currentPlan._plan.commission) / 100) * 20000,
        //         "currency"
        //       )} (${this.$n(100 - this.currentPlan._plan.commission)}%)`
        //     : "...",
        //   paymentTMT: "15/05/2023",
        // },
        // {
        //   period: "Março",
        //   totalGross: this.$n(14200, "currency"),
        //   netReceived: this.currentPlan
        //     ? `${this.$n(
        //         ((100 - this.currentPlan._plan.commission) / 100) * 14200,
        //         "currency"
        //       )}`
        //     : "...",
        //   amountReceivable: "-",
        //   paymentTMT: "Pago",
        // },
      ];
    },
  },
  methods: {
    async getCurrentPlan() {
      this.loadingPlan = true;
      const url = `whitelabel/signature`;
      await this.$axios
        .get(url)
        .then((response) => {
          const plan = response.data.data;
          this.currentPlan = plan;
          this.loadingPlan = false;
        })
        .catch((error) => {
          console.log(error);
          this.loadingPlan = false;
        });
    },
    loadDocuments() {
      this.loading = true;
      const firebase = initializeApp(config);
      const db = getFirestore(firebase);
      const q = query(collection(db, "accounts"));
      const querySnapshot = getDocs(q);
      const documents = [];
      querySnapshot.then((docs) => {
        docs.forEach((doc) => {
          const computed = {
            createdOn: moment(doc.data().createdOn).format(
              "DD/MM/YYYY HH:mm:ss"
            ),
          };
          documents.push({ ...doc.data(), computed: computed });
        });
        this.documents = documents;
        this.loading = false;
      });
    },
    loadOrders(){
      const res = []
      const firebase = initializeApp(config);
      const db = getFirestore(firebase);
      const q = query(collection(db, "orders"));
      const querySnapshot = getDocs(q);
      querySnapshot.then((docs) => {
        if (!docs.empty) {
          docs.forEach((doc) => {
           const data = doc.data()
           if(data.status == 'paid'){
            res.push({period: `${moment(data.range.start).format('DD/MM/YYYY')}-${moment(data.range.end).format('DD/MM/YYYY')}` ,totalGross: this.$n(data.total.final,'currency'), netReceived: this.$n(data.total.final, 'currency'), amountReceivable: this.$n(data.total.final, 'currency'), paymentTMT: '-' });
           }
          })
          this.docs = res
        }
      })
    }
  },
};
</script>

<style lang="scss">
.hide-text {
  font-size: 0;
  text-indent: -999em;
}
.--total-fin {
  tbody {
    tr:first-child {
      background: rgb(231, 235, 245);
    }
  }
}
</style>
